export interface RuntimeConfig {
  cognitoUserPoolId: string;
  cognitoClientId: string;
  cognitoRegion: string;
  apiUrl: string;
}

const defaults: RuntimeConfig = {
  cognitoUserPoolId: '',
  cognitoClientId: '',
  cognitoRegion: 'ap-southeast-2',
  apiUrl: 'https://api.amsleighpfa.com',
};

let cached: RuntimeConfig | null = null;

export const loadRuntimeConfig = async (): Promise<RuntimeConfig> => {
  if (cached) {
    return cached;
  }
  if (typeof window === 'undefined') {
    return defaults;
  }

  try {
    const response = await fetch('/runtime-config.json');
    if (response.ok) {
      const loaded = { ...defaults, ...(await response.json()) };
      cached = loaded;
      return loaded;
    }
  } catch {
    // fall through to defaults
  }

  cached = defaults;
  return defaults;
};

export const isAdminConfigured = (cfg: RuntimeConfig): boolean =>
  Boolean(cfg.cognitoUserPoolId && cfg.cognitoClientId && cfg.cognitoRegion);
